/**
 * BaseModel
 */
export default class BaseModel {

    constructor() {
        this.className = this.constructor.name;

    }

    getClassName() {
        return this.className;
    }

    exportClass() {
        const exported = {};
        for (const key of Object.keys(this)) {
            exported[key] = this[key];
        }
        return exported;
    }
}